module.exports = __webpack_public_path__ + "static/Background-mla-4.aecd1377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mla-4.jpg
// module id = 473
// module chunks = 172546399187757